define('controllers/financialinfo',['require'],function(require) {
    return function() {
        $("#TextBoxRoutingNumber").on("change", function () {
            var $this = $(this);

            $.ajax({
                type: 'POST',
                url: "/Public/BankLookupAJAX.aspx",
                data: { RoutingNumber: $this.val() },
                success: function (bankName) {
                    $("#TextBoxBankName").val(bankName);
                }
            });
        });
    };
});

